/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S2_Li5Inputs */

const tr_servis_s2_li5 = /** @type {(inputs: Servis_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödeme yöntemi olarak Sipay Sanal POS altyapısı üzerinden kredi kartı veya banka kartı ile ödeme ve Sağlayıcı'nın bildirdiği banka hesabına havale/EFT kabul edilmektedir; havale/EFT ile ödemede hizmet, bedelin hesaba ulaşmasının ardından aktif edilir.`)
};

const en_servis_s2_li5 = /** @type {(inputs: Servis_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment by credit or debit card via the Sipay Sanal POS infrastructure and bank transfer/EFT to the bank account stated by the Provider are accepted as payment methods; with bank transfer/EFT the service is activated once the amount has been received.`)
};

const de_servis_s2_li5 = /** @type {(inputs: Servis_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Zahlungsmethoden werden die Zahlung per Kredit- oder Bankkarte über die Sanal-POS-Infrastruktur von Sipay und die Überweisung/EFT auf das vom Anbieter genannte Bankkonto akzeptiert; bei Überweisung/EFT wird der Dienst nach Eingang des Betrags aktiviert.`)
};

const ru_servis_s2_li5 = /** @type {(inputs: Servis_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В качестве способов оплаты принимаются оплата кредитной или дебетовой картой через инфраструктуру Sipay Sanal POS и банковский перевод/EFT на указанный Поставщиком банковский счёт; при переводе/EFT услуга активируется после поступления суммы.`)
};

/**
* | output |
* | --- |
* | "Payment by credit or debit card via the Sipay Sanal POS infrastructure and bank transfer/EFT to the bank account stated by the Provider are accepted as payme..." |
*
* @param {Servis_S2_Li5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s2_li5 = /** @type {((inputs?: Servis_S2_Li5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S2_Li5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s2_li5(inputs)
	if (locale === "de") return de_servis_s2_li5(inputs)
	if (locale === "ru") return ru_servis_s2_li5(inputs)
	return tr_servis_s2_li5(inputs)
});